<template>
  <table style="margin-top: -10px;">
      <tbody>
        <tr >
          <td width="100"><v-switch :label="cab?'CAB':'EAN13'" v-model="cab"></v-switch></td>
          <td width="100"></td>
          <td width="200"><v-switch :label="repart?'Répartition':'Stock'" v-model="repart"></v-switch></td>
        </tr>
      </tbody>
  </table>
 
  <table style="margin-top: -30px;">
    <v-card>
      <tbody>
        <tr>
          <th width="100"  > Image</th>
          <th>Nom Appel</th>
          <th>Réf fourn</th>
          <th>Désignation</th>
          <th>Collection</th>
          <th>Dépot</th>
          <th>Mag</th>
          <th>Prix</th>
        </tr>
        <tr >
          <td  width="100" class="iconplus" @click="dialog=true">
            <v-icon class="iconplus" icon="mdi-plus"  ></v-icon>
          </td>
          <td>{{ props.references[Object.keys(props.references)[0]].reference_y2 }}</td>
          <td><input type="text" style="text-align:center" :value="props.references[Object.keys(props.references)[0]].ref_fourn" @change.prevent="updateReference('ref_fourn',$event.target.value)"/></td>
          <td><input type="text" style="text-align:center" :value="props.references[Object.keys(props.references)[0]].designation" @change.prevent="updateReference('designation',$event.target.value)"/></td>
          <td> 
            <select name="collections" id="collections" v-model="collectionRef" >
              <option  v-for="key in collections">{{key}}</option>
            </select>
          </td>
          <td>{{ sumAD(etabDEPO.etabliss) }}</td>
          <td>{{ sumAD(etabEdiFrNord.etabliss)+sumAD(etabEdiPDC.etabliss)+sumAD(etabEdiBE.etabliss)+sumAD(etabLc.etabliss)+sumAD(etabEtrier.etabliss)   }}</td>
          <td>€<input type="text" id="name" name="name"  :value="props.references[Object.keys(props.references)[0]].vte_euro" @change.prevent="updatePrix($event.target.value)" size="4"  /></td>
        </tr>
        <tr>
          <td width="100" class="iconrefresh" @click="refreshPrices()">
            <v-icon color="primary" class="iconrefresh" icon="mdi-refresh"  ></v-icon>
          </td>
          <td colspan="20" style="text-align:left">
            <input type="text"  :value="props.references[Object.keys(props.references)[0]].dimension" @change.prevent="updateReference('dimension',$event.target.value)"  size="6"/> //
            <input type="text"  :value="Number(props.references[Object.keys(props.references)[0]].poidsnet).toFixed(3)" @change.prevent="updateReference('POIDSNET',$event.target.value)"  size="2"/>  Kg
          </td>
          <td colspan="20"></td>
        </tr>
        <tr >
          <td rowspan="30" width="100" valign="top" ><img style="border: 0.1em  solid lightgrey"  @click="imageDialog=true;srcImage=`https://www.edisac.com/images/article_la/${props.references[Object.keys(props.references)[0]].imagename}`"  :src="`${props.references[Object.keys(props.references)[0]].imagename?'https://www.edisac.com/images/article_la/'+props.references[Object.keys(props.references)[0]].imagename:'https://www.edisac.com/images/article_la/nopic2.gif'}`" alt="Italian Trulli" width="100%" height="100%"> </td>
          <td colspan="20">
            <table>
              <tbody class="tableArticle">
                <tr style="border-bottom: 0.1em  solid;border-color:lightgrey ;">
                  <th width="90"> couleur</th>
                  <th width="40">taille</th>
                  <th width="50">Prix</th>
                  <th width="50" v-if="!visiblefunction&&!visible">Promo</th>
                  <th width="40" v-if="visiblefunction||visible">Remise</th>
                  <th width="60" v-if="visiblefunction||visible">Type</th>
                  <th width="50" v-if="visiblefunction||visible">Promo</th>
                  <th width="50" >Collec.</th>
                  <th  class="etabclass"  v-for="el in etabDEPO.etabliss " :key="el"><span>{{ el }}</span></th>
                  <th width="50" class="filiale" @click="edisacFrance()"><span >France </span></th>
                  <th class="etabclass"  v-if="edisacFranceCol"   v-for="el in etabEdiFrNord.etabliss " :key="el"> {{ el }}</th>
                  <th class="etabclass"  v-if="edisacFranceCol"   v-for="el in etabEdiPDC.etabliss " :key="el"> {{ el }}</th>
                  <th width="50" class="filiale" @click="edisacBelgique()"><span >Belgique </span> </th>
                  <th class="etabclass"  v-if="edisacBelgiqueCol"   v-for="el in etabEdiBE.etabliss " :key="el"> {{ el }}</th>
                  <th width="50" class="filiale" @click="edisacLongchamp()"><span >Longchamp </span> </th>
                  <th class="etabclass"  v-if="etabLcCol"   v-for="el in etabLc.etabliss " :key="el"> {{ el }}</th>
                  <th width="50" class="filiale" @click="edisacEtrier()"><span >Etrier </span> </th>
                  <th class="etabclass"  v-if="etabEtrierCol"   v-for="el in etabEtrier.etabliss " :key="el"> {{ el }}</th>
                  <th width="50" class="filiale" @click="edisacReflex()"><span >Reflex </span> </th>
                  <th class="etabclass"  v-if="etabReflexCol"   v-for="el in etabReflex.etabliss " :key="el"> {{ el }}</th>
                </tr>
                  <Color  
                    v-for="article in ordered(references)" 
                    :article 
                    :col 
                    :cab 
                    :repart 
                    v-model="visible" 
                    :visiblefunction 
                    @isChangedCol="()=>{isChanged=true}">
                  </Color>
              </tbody>
            </table> 
          </td>
        </tr>
      </tbody>
      <v-btn  block color="primary" v-if="isChanged"
          @click="validerArticles();loading=true">
          Valider
          <v-progress-linear indeterminate ></v-progress-linear>
      </v-btn>
      
    </v-card>
    <!-- <v-divider class="border-opacity-25"></v-divider> -->
    </table>
     <!-- <div class="pa-4 text-center"> -->
      <v-dialog
        v-model="dialog"
        max-width="400"
      ><v-card
          title="Fiche Article"
        ><v-card-text>
            <v-row dense>
              <v-col cols="12"  md="4" sm="6">
                <v-text-field 
                  label="Acheteur"
                  v-model="acheteur"
                  density="compact" variant="outlined"
                ></v-text-field>
              </v-col>
              <v-col  cols="12"  md="4"  sm="6">
                <v-text-field  label="Pôle"    v-model="pole" density="compact" variant="outlined"
                ></v-text-field>
              </v-col>
              <v-col  cols="12"  md="4"  sm="6">
                <v-text-field
                  label="Code dounier"
                  v-model="douanier"
                  density="compact" variant="outlined"
                ></v-text-field>
              </v-col>
              <v-col  cols="12" md="4"  sm="6">
                <v-text-field
                  label="Composition"
                  v-model="composition"
                  density="compact" variant="outlined"
                ></v-text-field>
              </v-col>
              <v-col cols="12"  md="4" sm="6">
                <v-text-field
                  label="Pays"
                  v-model="pays"
                  density="compact" variant="outlined"
                ></v-text-field>
              </v-col>
              <v-col  cols="12"  md="4" sm="6">
                <v-text-field
                  label="Fournisseur"
                  v-model="fournisseur"
                  density="compact" variant="outlined"
                ></v-text-field>
              </v-col>
              <v-col  cols="12"  md="4"  sm="6">
              <v-text-field
                  label="Code Thème"
                  v-model="codeTheme"
                  density="compact" variant="outlined"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4"  sm="6">
              <v-text-field
                  label="Code marque" 
                  v-model="codemarque"
                  density="compact" variant="outlined"
              ></v-text-field>
              
              </v-col>
              <v-col cols="12" md="4" sm="6">
                <v-text-field label="Prix Achat" v-model="PrixAchat" density="compact" variant="outlined"></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6" sm="6">
                  <v-btn color="red" v-if="articleInSolde().cond"
                    @click="articleInSolde().type.match(/sol/)?dialogSolde=true:deletePromo();dialogFinale=true"
                  >Supprimer pormo</v-btn>
              </v-col>
            </v-row>
            <small class="text-caption text-medium-emphasis">*indicates required field</small>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text="Fermer" variant="plain" @click="dialog = false" color="red"></v-btn>
            <v-btn color="primary" text="Valider" variant="plain" @click="dialog = false"></v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    <!-- </div> -->

    <!-- <div class="text-center pa-4"> -->
      <v-dialog v-model="dialogFinale" width="auto">
        <v-card max-width="400" prepend-icon="$error"
        :text="`La référence ${props.references[Object.keys(props.references)[0]].reference_y2} a été supprimé de la promotion ${props.references[Object.keys(props.references)[0]].type_promo}`"
        title="Supression promo"
        >
        <template v-slot:actions>
          <v-btn class="ms-auto" text="OK" @click="dialogFinale = false"></v-btn>
        </template>
        </v-card>
      </v-dialog>
    <!-- </div>  -->
    <!-- <div class="text-center pa-4"> -->
      <v-dialog v-model="dialogSolde" width="auto">
        <v-card max-width="400" prepend-icon="$error"
        :text="`La référence ${props.references[Object.keys(props.references)[0]].reference_y2} est en solde, selectionnez les démarque à suprrimer SVP!`"
        title="Suppression soldes"
        >
        <v-row>
            <v-checkbox label="D1" v-model="d1" style="margin-left: 20%;" ></v-checkbox>
            <v-checkbox label="D2" v-model="d2" ></v-checkbox> 
            <v-checkbox label="D3" v-model="d3" ></v-checkbox>
            <v-checkbox label="OT" v-model="ot" ></v-checkbox>
        </v-row>
        <template v-slot:actions>
            <v-btn color="red" text="Annuler" @click="dialogFinale = false;dialogFinale=false"></v-btn>
            <v-btn color="green" text="Valider" @click="deletePromo();dialogSolde = false;dialogFinale=true"></v-btn>
        </template>
        </v-card>
      </v-dialog>
    <!-- </div>  -->
    <!-- <div class="text-center pa-4"> -->
      <v-dialog
        v-model="imageDialog"
        width="600"
      >
        <v-card width="600">
            <v-img
                width="600"
                cover
                :src="srcImage"
            ></v-img>
        </v-card>
      </v-dialog>
    <!-- </div> -->
  
</template>
  <script setup>
  import {onMounted,computed, ref, watch, reactive} from 'vue'
  import Color from './Color.vue';
  import store from './store'
  import axios from 'axios'
  let isChanged=ref(false)
  let imageDialog=ref()
  const cab=ref(false)
  const dialog=ref(false)
  const repart=ref(false)
  const dialogFinale=ref(false)
  const PrixAchat=ref('')
  let d1=ref(false)
  let d2=ref(false)
  let d3=ref(false)
  let ot=ref(false)
  let dialogSolde=ref(false)
  const props= defineProps({
    references:Object
  })
  const ordered=(referenced) =>{
    return Object.keys(referenced).sort().reduce(
        (obj, key) => { 

          obj[key] = referenced[key]; 
          return obj;
        }, 
        {}
      );
  }
  let articleInSolde=()=>{
    let cond={cond:false,type:''}
    for (let i in props.references){
      if(props.references[i].type_promo.match(/sol/gmi)){        
        cond={cond:true,type:'solde'}
        return cond
      }
      if(props.references[i].type_promo!=''){
        cond={cond:true,type:props.references[i].type_promo}
        return cond
      }
    } 
    return cond
  }
  const sumAD=(depo)=>{
    let sum=0
    for(let dep in depo){
      for (let cab in props.references) {
          sum=sum+(props.references[cab].stock[depo[dep]]?Number(props.references[cab].stock[depo[dep]]):0)
      }
    }
    return sum
  }
  let visible=defineModel(false)

  let visiblefunction=computed(()=>{
      let cond=false
      for(let key in props.references)
      { if(props.references[key].type_promo!=''){
        return cond=true
        }
      }
      
      return cond
  })
  const etabDEPO=ref({'filliale':'DEPOT', 'etabliss':['DEPO','DWEB']})
  const etabAD=ref({'filliale':'AD', 'etabliss':['DEFEC','DEPAD','LITIG','NEGO','PHOTO','RECEP','TRANS']})
  const etabReflex=ref({'filliale':'Reflex', 'etabliss':['WEDI','WEBE','WENL','WETR','WOOM','WCAM','WAMZ']})
  const etabEtrier= ref({'filliale':'Etrier', 'etabliss':['CA24','VX05','PR25']})
  const etabEdiBE=ref({'filliale':'Edisac Belgique', 'etabliss':['BR08','NP19','GE22','OO10']})
  const etabEdiFrNord=ref({'filliale':'Edisac Nord', 'etabliss':['DK03','MN01','EN11','FT04','LI02','RO06',]})
  const etabEdiPDC=ref({'filliale':'Edisac PDC', 'etabliss':['AR09','CO18','HB21']})
  const etabLc=ref({'filliale':'Lonchamp', 'etabliss':['LO07']})
  const edisacFranceCol=ref(false)
  const edisacBelgiqueCol=ref(false)
  const etabLcCol=ref(false)
  const etabReflexCol=ref(false)
  const etabEtrierCol=ref(false)
  let loading=ref(false)

    const acheteur=ref(props.references[Object.keys(props.references)[0]].acheteur)
    const pole=ref(props.references[Object.keys(props.references)[0]].pole)
    const douanier=ref(props.references[Object.keys(props.references)[0]].code_catdouanie)
    const codeTheme=ref(props.references[Object.keys(props.references)[0]].code_theme)
    const pays=ref(props.references[Object.keys(props.references)[0]].code_paysorigine)
    const composition=ref(props.references[Object.keys(props.references)[0]].code_composition)
    const fournisseur=ref(props.references[Object.keys(props.references)[0]].code_fourn)
    const codemarque=ref(props.references[Object.keys(props.references)[0]].code_marque)
    // const PrixAchat=ref('')



  const collectionRef=ref(props.references[Object.keys(props.references)[0]].collection)
  let col=ref({
    'edisacFranceCol':edisacFranceCol,
    'edisacBelgiqueCol':edisacBelgiqueCol,
    'etabLcCol':etabLcCol,
    'etabReflexCol':etabReflexCol,
    'etabEtrierCol':etabEtrierCol
  }
      
      
    )
  const edisacBelgique=()=>{
    edisacBelgiqueCol.value=!edisacBelgiqueCol.value
    edisacFranceCol.value=false
    etabLcCol.value=false
    etabEtrierCol.value=false
    etabReflexCol.value=false
  }
  const edisacFrance=()=>{
    edisacFranceCol.value=!edisacFranceCol.value
    etabLcCol.value=false
    etabEtrierCol.value=false
    etabReflexCol.value=false
    edisacBelgiqueCol.value=false
  }
  const edisacLongchamp=()=>{
    etabLcCol.value=!etabLcCol.value
    etabEtrierCol.value=false
    etabReflexCol.value=false
    edisacBelgiqueCol.value=false
    edisacFranceCol.value=false 
  }
  const edisacEtrier=()=>{
    etabEtrierCol.value=!etabEtrierCol.value
    etabReflexCol.value=false
    edisacBelgiqueCol.value=false
    edisacFranceCol.value=false 
    etabLcCol.value=false
    
  }
  const edisacReflex=()=>{
    etabReflexCol.value=!etabReflexCol.value
    edisacBelgiqueCol.value=false
    edisacFranceCol.value=false 
    etabLcCol.value=false
    etabEtrierCol.value=false
    
  }


  let collections=ref([`${collectionRef}`,'E23','E24','E25','H23','H24','H25','R23','R24','R25'].filter(el=>el!=collectionRef))

  
  watch(collectionRef,(newcol,oldcol)=>{
      store.commit('updateIsChangedCol',{key:'ficheArticle',value:true})
      // isChanged.value=true
      let referenceCol=props.references[Object.keys(props.references)[0]]
      let articlesTab=store.state.articles[referenceCol.code_marque][referenceCol.code_theme][referenceCol.reference_y2]
      for(let key in articlesTab){
        if(store.state.articles[referenceCol.code_marque][referenceCol.code_theme][referenceCol.reference_y2][key].collection==oldcol){
          store.commit('updateCollection',{'referenceCol':referenceCol,'key':key,'collection':{newcol,oldcol}})
        }
      } 
  })
  const validerArticles=()=>{
    
    let referenceCol=props.references[Object.keys(props.references)[0]]
    let data = {articles:{...store.state.articles[referenceCol.code_marque][referenceCol.code_theme][referenceCol.reference_y2]},isChanged:store.state.isChangedCol}
    let config = {
    method: 'post',
    maxBodyLength: Infinity,
    url: 'https://my.edisac.com/api/articles',
    headers: { 
        'Content-Type': 'application/json'
    },
    data : data
    }
    loading.value=false
    return axios.request(config)
    .then((response) => { 
        // console.log(response);
        store.commit('updateIsChangedCol',{key:'ficheArticle',value:false})
        store.commit('updateIsChangedCol',{key:'promo',value:false})
        
    })
    .catch((error) => {
    //console.log(error);
    });



 }

  const updatePrix=(value)=>{
    store.commit('updateIsChangedCol',{key:'prixBase',value:true})
    let referenceCol=props.references[Object.keys(props.references)[0]]
    let oldPrix=value
    let newPrix=value
    let articlesTab=store.state.articles[referenceCol.code_marque][referenceCol.code_theme][referenceCol.reference_y2]
    for(let key in articlesTab){
      store.commit('updatePrix',{'referenceCol':referenceCol,'key':key,'prix':{oldPrix,newPrix}})
    }  
  }
  const updateReference=(champs,value)=>{
    store.commit('updateIsChangedCol',{key:'ficheArticle',value:true})
    let referenceCol=props.references[Object.keys(props.references)[0]]
    let articlesTab=store.state.articles[referenceCol.code_marque][referenceCol.code_theme][referenceCol.reference_y2]
    for(let key in articlesTab){
      store.commit('updateReference',{'referenceCol':referenceCol,'key':key,'data':{champs,value}})
    }  
  }


  const deletePromo=()=>{
    let solde=(d1.value||d2.value||d3.value||ot.value)?{d1:d1.value?'d1':false,d2:d2.value?'d2':false,d3:d3.value?'d3':false,ot:ot.value?'ot':false}:false
    let data = {articles:props.references,solde:solde,user:store.state.user}
    let config = {
    method: 'post',
    maxBodyLength: Infinity,
    url: 'https://my.edisac.com/api/deletepromo',
    headers: { 
      'Content-Type': 'application/json'
    },
    data : data
    }
    return axios.request(config)
    .then((response) => { 
      if(response){
        store.commit('deletePromo',{marque:props.references[Object.keys(props.references)[0]].code_marque,theme:props.references[Object.keys(props.references)[0]].code_theme,reference:props.references[Object.keys(props.references)[0]].reference_y2})
        d1.value=false;
        d2.value=false;
        d3.value=false;
        ot.value=false;
      }    
    })
    .catch((error) => {
    //console.log(error);
    });
  }
  async function getBarCodes(){
    let barCodes=''
    for (let barcode in props.references ){
      barCodes=barCodes+`&barcodes=${props.references[barcode].codebarre}`
    }
    return barCodes
  }
  async function refreshPrices(){
    let referenceCol= props.references[Object.keys(props.references)[0]]
    let config = {
      method: 'get',
      maxBodyLength: Infinity,
      url: `/cegid-api/Y2/98661025_001_PROD/api/stores/${store.state.etablissement}/selling-prices/v1?taxExcluded=false&date=${store.state.date}${ await getBarCodes()}`, //
      
      
      headers: { 
        'Authorization': `Bearer ${store.state.token_y2}`, 
        'Content-Type': 'application/json'
      }
    };
    // console.log(config.url);
    axios.request(config)
    .then((response) => {
      for( let price in response.data.prices){
        // if(response.data.prices[price].periodId!=store.state.articles[referenceCol.code_marque][referenceCol.code_theme][referenceCol.reference_y2][response.data.prices[price].barcode].type_promo){
          if(response.data.prices[price].unitPrice.base!=response.data.prices[price].unitPrice.current){
            store.state.articles[referenceCol.code_marque][referenceCol.code_theme][referenceCol.reference_y2][response.data.prices[price].barcode].prix_promo=response.data.prices[price].unitPrice.current.toFixed(1)
            store.state.articles[referenceCol.code_marque][referenceCol.code_theme][referenceCol.reference_y2][response.data.prices[price].barcode].type_promo=response.data.prices[price].periodId
            store.state.articles[referenceCol.code_marque][referenceCol.code_theme][referenceCol.reference_y2][response.data.prices[price].barcode].vte_euro=response.data.prices[price].unitPrice.base.toFixed(3)
          }else{
            store.state.articles[referenceCol.code_marque][referenceCol.code_theme][referenceCol.reference_y2][response.data.prices[price].barcode].prix_promo=0
            store.state.articles[referenceCol.code_marque][referenceCol.code_theme][referenceCol.reference_y2][response.data.prices[price].barcode].type_promo=''
            store.state.articles[referenceCol.code_marque][referenceCol.code_theme][referenceCol.reference_y2][response.data.prices[price].barcode].vte_euro=response.data.prices[price].unitPrice.base.toFixed(3)
          }
        // }
      }
    })
    .catch((error) => {
      //console.log(error);
    })  
  }

  onMounted(() => {
    // console.log(props.references[Object.keys(props.references)[0]].value);
    // visiblefunction()
    
    
  })



  
  </script>
  <style>
td{
    /* border-right: solid 1px;
    border-bottom: solid 1px; */
    text-align: center;
    font-size: 10px;
  }
th{

    text-align: center;
    font-size: 10px;
    background-color: antiquewhite;

  }
tbody{
    font-size: 10px;
    border-collapse: separate; 
  border-spacing: 5em;
  }
  
  .codebarre{  
    border-top:0.01rem solid;
    border-color:lightgrey ;

  }
  .filiale {
    color:blue;
    cursor: pointer;
  }
  .filiale:hover{
    background-color: lightgrey
  }
  .iconplus{
    cursor: pointer;
  }
  .iconplus:hover{
    background-color: antiquewhite;
  }
  .iconrefresh{
    cursor: pointer;
  }
  .iconrefresh:hover{
    background-color: rgb(164, 223, 228);
  }
  .tableArticle{
    
    border: 0.1em  solid;
    border-color:lightgrey ;
  }

  </style>